module.exports = __webpack_public_path__ + "static/AtlasGrotesk-Regular-Web-b524891894425b61997a9e7d32f38bf2.woff2";